export default __webpack_public_path__ + "static/back_img_1-a1359f9cd13684dfc525d2f1d3d0fd91.png";